import { focusable } from 'tabbable'

const handleFirstTab = (e) => {
  if (e.keyCode === 9) {
    document.body.classList.add('user-is-tabbing')

    window.removeEventListener('keydown', handleFirstTab)
    window.addEventListener('mousedown', handleMouseDownOnce)
  }
}

const handleMouseDownOnce = () => {
  document.body.classList.remove('user-is-tabbing')

  window.removeEventListener('mousedown', handleMouseDownOnce)
  window.addEventListener('keydown', handleFirstTab)
}

window.addEventListener('keydown', handleFirstTab)

const updateTitleIframes = () => {
  setTimeout(() => {
    const iframePixels = document.querySelector('#WebPixelsManagerSandboxContainer iframe')
    const iframeWebMessenger = document.querySelector('#web-messenger-container')
    const joinAdInterestGroup = document.querySelector('iframe[allow="join-ad-interest-group"]')
    const grecaptchaBadge = document.querySelector('.grecaptcha-badge iframe')

    if (iframePixels) {
      iframePixels.setAttribute('title', 'WebPixels Manager Sandbox')
    }

    if (iframeWebMessenger) {
      iframeWebMessenger.setAttribute('title', 'Web Messenger')
    }

    if (grecaptchaBadge) {
      grecaptchaBadge.setAttribute('title', 'Grecaptcha Badge')
    }

    if (joinAdInterestGroup) {
      joinAdInterestGroup.setAttribute('title', 'Join ad Interest Group')
      joinAdInterestGroup.setAttribute('tabindex', '-1')
    }
  }, 2000)
}

updateTitleIframes()

const trapFocusHandlers = {}

const removeTrapFocus = (elementToFocus = null) => {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

const trapFocus = (container, elementToFocus = container) => {
  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    const elements = focusable(container)
    const first = elements[0]
    const last = elements[elements.length - 1]

    if (event.target !== container && event.target !== last && event.target !== first) return

    document.addEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    const elements = focusable(container)
    const first = elements[0]
    const last = elements[elements.length - 1]

    if (event.code.toUpperCase() !== 'TAB') return // If not TAB key

    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener('focusout', trapFocusHandlers.focusout)
  document.addEventListener('focusin', trapFocusHandlers.focusin)

  elementToFocus.focus()

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length)
  }
}

export {
  trapFocus,
  removeTrapFocus
}
